import { Fab, Typography } from '@mui/material';
import Iconify from "./minimal/iconify/index.jsx";
import { useMarketplaceContext } from '../context-state/MarketplaceContext.jsx';
import { useLocales } from '../locales';

const isMobile = window.innerWidth < 600;

const WhatsappSupport = () => {
    const { marketplace } = useMarketplaceContext();
    const { translate } = useLocales();
    const phoneNumber = marketplace?.supportWhatsapp;
    const dynamicText = translate('whatsapp_support');
    const hoverWidth = `calc(0.7rem * ${dynamicText.length})`;
    if (!phoneNumber) return null;
    return (<a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
        <Fab sx={{
            zIndex: 10000000,
            bottom: isMobile ? '13px' : '26px',
            left: isMobile ? '13px' : '26px',
            backgroundColor: "#00c217",
            transition: "all .5s",
            borderRadius: "40px",
            display: "flex",
            padding: "8px",
            justifyContent: "space-between",
            overflow: "hidden",
            '&:hover': {
                backgroundColor: "#00a914",
                width: hoverWidth,
            },
            '& .MuiTypography-subtitle2': {
                transition: "all .5s",
                fontSize: "1rem",
                opacity: 0,
                overflow: "hidden",
                display: "inline-block",
                // keep the text on one line
                whiteSpace: "nowrap",
                width: "0px",
            },
            '&:hover .MuiTypography-subtitle2': {
                opacity: 1,
                overflow: "visible",
                width: hoverWidth,
            },
            color: "white"
        }} aria-label="whatsapp" size={isMobile ? 'medium' : 'large'} >
            <Iconify icon="mdi:whatsapp" width={isMobile ? 35 : 40} />
            <Typography variant="subtitle2" >
                {translate('whatsapp_support')}
            </Typography>
        </Fab>
    </a>);
}

export default WhatsappSupport;